<div class="custom-table" [nbSpinner]="isLoading">
  <ng2-smart-table
    [class.empty]="isEmpty"
    [settings]="settings"
    [source]="source"></ng2-smart-table>
</div>
